import { getChainOfferRemainingMs, formatChainOfferRemaining } from "../chain_offer_screen/chain_offer_timer.js";

export function getChainVideoRemainingMs(): number | null
{
  return getChainOfferRemainingMs( 'chain_video' );
}

export function formatChainVideoRemaining( ms: number | null ): string
{
  return formatChainOfferRemaining( ms );
}
